import { API_AUTH, API_AUTH_FILE } from "../../common";

const DanhSachKhachHangApi = {
  getList: (params) => API_AUTH.get("api/customer/DanhSach", params),
  getById: (id, dbName) => API_AUTH.get(`api/customer/ChiTiet?id=${id}&dbName=${dbName}`),
  create: (data) => API_AUTH.post("api/customer/Create", data),
  update: (id, data, dbName) => API_AUTH.put(`api/customer/Update?id=${id}&dbName=${dbName}`, data),
  delete: (id, dbName) => API_AUTH.delete(`api/customer/Delete?id=${id}&dbName=${dbName}`),
  xuatExcel: (filters) => {
    const params = { ...filters };
    return API_AUTH_FILE.get("api/customer/XuatExcel", params, { responseType: 'blob' });
  },
};

export default DanhSachKhachHangApi;